"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../index");
const Document = () => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container-px mb-5xl sm:mb-9xl", children: [(0, jsx_runtime_1.jsx)(index_1.DocumentHeader, {}), (0, jsx_runtime_1.jsx)(index_1.DocumentBody, {}), (0, jsx_runtime_1.jsx)(index_1.ErrorMessage, {})] }));
};
exports.Document = Document;
